import { copy } from './i18n';
import type { Locale, ProjectView } from './types';

export const syntheticProject: ProjectView = {
  id: 'project_synthetic_harbor',
  name: 'Synthetic Harbor · family week',
  stage: 'preview',
  snapshotAt: '2030-04-12T09:30:00.000Z',
  digest: '9b96c1ef3263ba674fce2dbf82099bd33363785542f9008e574cb4a4846a45ea',
  previewCredits: 48,
  fullCredits: 5,
  devices: 2,
  answers: {
    destination: 'Synthetic Harbor',
    dates: '2030-06-14 — 2030-06-20',
    travelers: '2 adults, 1 child',
    pace: 'balanced',
    priorities: 'Architecture, markets, easy waterfront walks',
    constraints: 'Vegetarian meals; step-free alternatives required',
  },
  unresolved: [
    'Museum summer hours are not yet published.',
    'Accessible entrance location conflicts across two sources.',
  ],
};

export function previewHtml(locale: Locale): string {
  const t = copy[locale];
  const direction = locale === 'he' ? 'rtl' : 'ltr';
  return `<!doctype html><html lang="${locale}" dir="${direction}"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width"><style>
body{font-family:system-ui,sans-serif;color:#183d36;background:#fffdf7;margin:0;padding:28px;line-height:1.55}h1{font-size:2rem;margin:.2em 0}.tag{display:inline-block;background:#ddf2e9;padding:5px 10px;border-radius:20px}article{border-top:1px solid #dce4df;margin-top:22px;padding-top:18px}.unknown{background:#fff2cd;padding:12px;border-radius:10px}small{color:#63736d}
</style></head><body><span class="tag">${t.guideTag}</span><h1>${t.guideTitle}</h1><p>${t.guideIntro}</p><article><small>${t.guideDayOne}</small><h2>${t.guideDayOneTitle}</h2><p>${t.guideDayOneBody}</p></article><article><small>${t.guideDayTwo}</small><h2>${t.guideDayTwoTitle}</h2><p>${t.guideDayTwoBody}</p><p class="unknown"><strong>${t.guideVerify}</strong> ${t.guideUnknown}</p></article></body></html>`;
}
